import React from 'react';
import { BottomTabBarProps } from '@react-navigation/bottom-tabs';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import {
  Bar,
  TabButton,
  IconWrapper,
  Label,
} from './styles';
import { themes } from '../../design/colors';

/**
 * Barra inferior compartilhada pelos fluxos de Admin e Motorista.
 * Substitui a tabBar padrão do @react-navigation/bottom-tabs (que vem sem
 * nenhum estilo próprio) por um cartão flutuante com o item ativo destacado
 * em um "pill", mantendo os ícones já definidos em cada Tab.Screen
 * (options.tabBarIcon) — só muda a casca visual, não a navegação.
 */
export default function TabBar({ state, descriptors, navigation }: BottomTabBarProps) {
  const insets = useSafeAreaInsets();

  return (
    <Bar style={{ paddingBottom: Math.max(insets.bottom, 12) }}>
      {state.routes.map((route, index) => {
        const { options } = descriptors[route.key];
        const focused = state.index === index;
        const label = (options.title ?? route.name) as string;

        function onPress() {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
            canPreventDefault: true,
          });

          if (!focused && !event.defaultPrevented) {
            navigation.navigate(route.name);
          }
        }

        return (
          <TabButton
            key={route.key}
            accessible
            accessibilityRole="button"
            accessibilityState={focused ? { selected: true } : {}}
            accessibilityLabel={label}
            onPress={onPress}
            activeOpacity={0.7}
          >
            <IconWrapper focused={focused}>
              {options.tabBarIcon?.({
                focused,
                color: focused ? themes.colors.primary : themes.colors.gray1,
                size: 22,
              })}
            </IconWrapper>
            <Label focused={focused}>{label}</Label>
          </TabButton>
        );
      })}
    </Bar>
  );
}
